// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZEopYUmvfs28AI6r6uIA{width:100%}.vEUs_L3wUi7vb0ES25zs{margin-bottom:5px;margin-left:5px}.S1EJZ5dXEL0TBZ5WzDNA{max-width:0}", "",{"version":3,"sources":["webpack://./src/applab/play-space-header.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CAGF,sBACE,iBAAA,CACA,eAAA,CAGF,sBACE,WAAA","sourcesContent":[".table {\n  width: 100%;\n}\n\n.segmentedButtonsWrapper {\n  margin-bottom: 5px;\n  margin-left: 5px;\n}\n\n.rightCell {\n  max-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": "ZEopYUmvfs28AI6r6uIA",
	"segmentedButtonsWrapper": "vEUs_L3wUi7vb0ES25zs",
	"rightCell": "S1EJZ5dXEL0TBZ5WzDNA"
};
export default ___CSS_LOADER_EXPORT___;
